import React from "react";
import Wrapper from "./errorModal.styles";
import { Modal } from "@components/modal";
import ErrorMessageRestart from './errorMessageRestart';
import { FooterButtons } from "@components/modal/footerButtons";
import { ModalButton } from "@components/modal/modalButton";
import PropTypes from 'prop-types';

export default function ErrorModal({ ...props }) {
    const {
        values: {
        firstName,
        } = {},
        buttonText = "Restart Application",
      } = props;

    // if form contains an ID then show the Contact Us message.
    // if for doesn't conain an ID then show the restart message.
    let errorMessage = <ErrorMessageRestart firstName={firstName} />
    let button = (
          <ModalButton onClick={props.restart}>
            {buttonText}
          </ModalButton>
    );

    return (
      <Modal
        visible={props.visible}
        header="Unfortunately, something went wrong"
        size="extra-small"
        footer={
            <FooterButtons>
                {button}
            </FooterButtons>
        }
        onClose={props.close}
      >
        <Wrapper>
          <div className="modalContent">
            {errorMessage}
          </div>
        </Wrapper>
      </Modal>
    );    
}

ErrorModal.propTypes = {
  firstName : PropTypes.string,
  buttonText : PropTypes.string,
  values : PropTypes.any,
  restart : PropTypes.func,
  visible : PropTypes.bool,
  close : PropTypes.any
};

